<apx-chart
  [series]="series"
  [chart]="options.chart"
  [plotOptions]="plotOptions"
  [stroke]="options.stroke"
  [states]="options.states"
  [colors]="color"
></apx-chart>
